import { defineComponent as _defineComponent } from 'vue'
import store from "@/store";
  import { computed, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import { formatDate } from "@/helpers/date";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Enquiries',
  setup(__props, { expose: __expose }) {
  __expose();

  const route = useRoute();

  const enquiries = ref([]);
  const loading = ref(true);
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });
  const leadId = computed(() => {
    return route.params.id;
  });

  onMounted(() => {
    store
      .dispatch("contact/getEnquiries", {
        estateId: estateId.value,
        leadId: leadId.value,
      })
      .then((res) => {
        enquiries.value = res.data[0]?.messages;
      })
      .finally(() => {
        loading.value = false;
      });
  });

const __returned__ = { route, enquiries, loading, estateId, leadId, get store() { return store }, computed, onMounted, ref, get useRoute() { return useRoute }, get formatDate() { return formatDate } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})